import React from 'react';
import {os} from '../../../Constants/Constants';
import {webDevelopment} from '../../../Constants/Constants';
import {misc} from "../../../Constants/Constants";
import {lang} from "../../../Constants/Constants";
import LanguageIcon from '@mui/icons-material/Language';
import RuleIcon from '@mui/icons-material/Rule';
import FlipToFrontIcon from '@mui/icons-material/FlipToFront';
import AndroidIcon from '@mui/icons-material/Android';

import "./Skills.css";


function Skills() {

    const showOs =os.map(os =>(<li> {os}</li>))
    const showWebDevelopment = webDevelopment.map(wd =>( <li>{wd}</li>))
    const showMisc = misc.map(tech => (<li>{tech}</li>))
    const showLang = lang.map(lan => (<li>{lan}</li>))
    return (

        <div className="skills">
        <div className="headingSkills"><h1>Skills</h1></div>

        <div className="Content">
            <div> <h3> <AndroidIcon/>Operating Systems</h3> {showOs} </div>
            <div> <h3> <FlipToFrontIcon/> Frontend Technologies</h3> {showWebDevelopment} </div>
            <div> <h3> <RuleIcon/>Miscellaneous</h3> {showMisc} </div>
            <div> <h3> <LanguageIcon/> Languages </h3> {showLang}</div>
        </div>
        </div>
    )
}

export default Skills;
